import { __extends } from "tslib";
// DS: PO20
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import Modal, { MODAL_FOOTER_BUTTON_SIZE, } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Sidebar from '../_partials/Sidebar';
import { MediaSourceType, MediaPopupMode } from '../types';
import { DEFAULT_MEDIASOURCE_TYPES, MAX_SELECTED_ITEMS } from '../constants';
import MediaSourceMenu from '../_partials/MediaSourceMenu';
import GallectionManager from '../Gallections/GallectionManager';
import GallectionContentManager from '../Gallections/GallectionContentManager';
import CustomSetDeviationManager from '../Deviations/DeviationManager/CustomSetDeviationManager';
import withOwnReduxStore from '../_hocs/withOwnReduxStore';
import withCurrentMediaSource from '../_hocs/withCurrentMediaSource';
import withCurrentGallection from '../_hocs/withCurrentGallection';
import withMediaPopupInit from '../_hocs/withMediaPopupInit';
import withCustomSetDeviations from '../_hocs/withCustomSetDeviations';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import withCurrentTier from '../_hocs/withCurrentTier';
import ModalsForMM from '../_partials/ModalsForMM';
import TierDeviationManager from '../Deviations/DeviationManager/TierDeviationManager';
import TierExplorer from '../Tiers/TierExplorer';
import mediaPopupStyles from '../MediaPopup.scss';
var enhance = compose(withOwnReduxStore, withCurrentMediaSource, withMediaPopupInit, withCurrentGallection, withCurrentTier, withCustomSetDeviations, // for onDone event
withMobileContext, withTranslation());
var MediaManager = /** @class */ (function (_super) {
    __extends(MediaManager, _super);
    function MediaManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDone = function () {
            var _a = _this.props, deviations = _a.deviations, currentMediaSource = _a.currentMediaSource;
            if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
                _this.props.onDone(deviations);
            }
            else {
                _this.props.onDone();
            }
        };
        return _this;
    }
    MediaManager.prototype.componentDidMount = function () {
        var _a = this.props, initialMediaSource = _a.initialMediaSource, initialDeviationSet = _a.initialDeviationSet, initMediaPopup = _a.initMediaPopup, gallectionFolder = _a.gallectionFolder, gallectionFolders = _a.gallectionFolders, tier = _a.tier, allowedDeviationTypes = _a.allowedDeviationTypes, mediaSourceTypes = _a.mediaSourceTypes, withMediaSourceSelector = _a.withMediaSourceSelector, _b = _a.withNewGallectionPopupOpen, withNewGallectionPopupOpen = _b === void 0 ? false : _b, _c = _a.withAddDeviationsPopupOpen, withAddDeviationsPopupOpen = _c === void 0 ? false : _c, _d = _a.onlyNewPaidFolders, onlyNewPaidFolders = _d === void 0 ? false : _d, _e = _a.allowUploads, allowUploads = _e === void 0 ? true : _e;
        var selectionLimit = MAX_SELECTED_ITEMS;
        var mediaSource = initialMediaSource;
        if (initialDeviationSet) {
            mediaSource = MediaSourceType.CUSTOM_SET;
        }
        initMediaPopup({
            mode: MediaPopupMode.MANAGER,
            mediaSource: mediaSource,
            initialDeviationSet: initialDeviationSet,
            selectionLimit: selectionLimit,
            gallectionFolder: gallectionFolder,
            gallectionFolders: gallectionFolders,
            tier: tier,
            allowedDeviationTypes: allowedDeviationTypes,
            mediaSourceTypes: mediaSourceTypes,
            withMediaSourceSelector: withMediaSourceSelector,
            withNewGallectionPopupOpen: withNewGallectionPopupOpen || onlyNewPaidFolders,
            withAddDeviationsPopupOpen: withAddDeviationsPopupOpen,
            onlyNewPaidFolders: onlyNewPaidFolders,
            allowUploads: allowUploads,
        });
    };
    MediaManager.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, withMediaSourceSelector = _a.withMediaSourceSelector, t = _a.t, isMobile = _a.isMobile;
        if (isMobile) {
            // MediaManager is not supported on mobile
            // only MediaSelector
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { isOpen: true, className: mediaPopupStyles['root'], contentClassName: mediaPopupStyles['content'], heading: this.getTitle(), showHeaderBorder: true, showFooterBorder: true, onRequestClose: function () { return onClose(); }, footerRight: [
                    React.createElement(BrandedButton, { key: "done", variant: "brand-green", size: MODAL_FOOTER_BUTTON_SIZE, onClick: this.onDone }, t('mediapopup.done')),
                ] },
                withMediaSourceSelector && (React.createElement(Sidebar, null,
                    React.createElement(MediaSourceMenu, { mediaSourceTypes: [
                            MediaSourceType.GALLERY,
                            MediaSourceType.COLLECTION,
                        ] }))),
                this.renderContentArea()),
            React.createElement(ModalsForMM, null)));
    };
    MediaManager.prototype.renderContentArea = function () {
        var _a = this.props, initialDeviationSet = _a.initialDeviationSet, currentMediaSource = _a.currentMediaSource, currentGallection = _a.currentGallection, currentTier = _a.currentTier;
        if (initialDeviationSet) {
            return React.createElement(CustomSetDeviationManager, null);
        }
        if (currentMediaSource &&
            [MediaSourceType.TIER_DEVIATIONS, MediaSourceType.TIER_POSTS].includes(currentMediaSource)) {
            if (currentTier) {
                return React.createElement(TierDeviationManager, null);
            }
            return React.createElement(TierExplorer, null);
        }
        if (!currentGallection) {
            return React.createElement(GallectionManager, null);
        }
        return React.createElement(GallectionContentManager, null);
    };
    MediaManager.prototype.getTitle = function () {
        var _a = this.props, currentMediaSource = _a.currentMediaSource, t = _a.t, title = _a.title;
        if (title) {
            return title;
        }
        switch (currentMediaSource) {
            case MediaSourceType.GALLERY:
                return t('mediapopup.editYourGalleries');
            case MediaSourceType.COLLECTION:
                return t('mediapopup.editYourCollections');
            case MediaSourceType.CUSTOM_SET:
                return t('mediapopup.editYourGallery');
            case MediaSourceType.STASH:
                return t('mediapopup.editYourStash');
            default:
                return t('mediapopup.title');
        }
    };
    MediaManager.defaultProps = {
        initialMediaSource: MediaSourceType.GALLERY,
        withMediaSourceSelector: false,
        mediaSourceTypes: DEFAULT_MEDIASOURCE_TYPES,
        withNewGallectionPopupOpen: false,
        withAddDeviationsPopupOpen: false,
        onlyNewPaidFolders: false,
    };
    return MediaManager;
}(React.Component));
export default enhance(MediaManager);
//# sourceMappingURL=MediaManager.connected.js.map